/*
 *
 * Cart
 *
 */

import React from "react";
import { connect } from "react-redux";

import actions from "../../actions";

import CartList from "../../components/Store/CartList";
import CartSummary from "../../components/Store/CartSummary";
import Checkout from "../../components/Store/Checkout";
import { BagIcon, CloseIcon } from "../../components/Common/Icon";
import Button from "../../components/Common/Button";
import Switch, { SwitchProps } from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import GridViewIcon from "@mui/icons-material/GridView";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";

class Cart extends React.PureComponent {
  render() {
    const {
      isCartOpen,
      cartItems,
      cartTotal,
      cartQtyTotal,
      cartstyle,
      setCartPrice,
      setcartdiscount,
      cartdiscount,
      toggleCartStyle,
      toggleEditPrice,
      toggleEditQty,
      isEditSumm,
      toggleEditSumm,
      toggleCart,
      handleShopping,
      handleCheckout,
      handleRemoveFromCart,
      handle_AddOneToCart,
      handle_RemoveOneFromCart,
      handle_itemDiscaunt,
      placeOrder,
      authenticated,
      isEditPrice,
      isEditQty,
      alltovs,
      isXSmall,
      dispatch,
    } = this.props;

    return (
      <div className="cart">
        <div className="cart-header">
          <GridViewIcon
            style={{
              marginRight: 10,
              marginLeft: 10,
              //
              backgroundColor: cartstyle ? "#00ff9f54" : "", //#e4e6eb":"",
            }}
            onClick={() => {
              toggleCartStyle();
            }}
          />
          <div>
            <span
              onClick={() => {
                toggleEditPrice();
              }}
            >
              Цена
            </span>
            {isEditPrice ? (
              <EditIcon
                style={{
                  marginRight: 10,
                  marginLeft: 10,
                  backgroundColor: isEditPrice ? "#00ff9f54" : "", //#e4e6eb":"",
                }}
                onClick={() => {
                  toggleEditPrice();
                }}
              />
            ) : (
              <EditOffIcon
                style={{
                  marginRight: 10,
                  marginLeft: 10,
                  //backgroundColor: isEditPrice ? "#00ff9f54" : "", //#e4e6eb":"",
                }}
                onClick={() => {
                  toggleEditPrice();
                }}
              />
            )}
          </div>
          <div>
            <span
              onClick={() => {
                toggleEditQty();
              }}
            >
              Кол-во
            </span>
            {isEditQty ? (
              <EditIcon
                style={{
                  marginRight: 10,
                  marginLeft: 10,
                  //
                  backgroundColor: isEditQty ? "#00ff9f54" : "", //#e4e6eb":"",
                }}
                onClick={() => {
                  toggleEditQty();
                }}
              />
            ) : (
              <EditOffIcon
                style={{
                  marginRight: 10,
                  marginLeft: 10,
                  //
                  //backgroundColor: isEditQty ? "#00ff9f54" : "", //#e4e6eb":"",
                }}
                onClick={() => {
                  toggleEditQty();
                }}
              />
            )}
          </div>
          {isCartOpen && (
            <Button
              className="close-the-cart"
              borderless
              variant="empty"
              ariaLabel="close the cart"
              icon={<CloseIcon />}
              onClick={toggleCart}
            />
          )}
        </div>
        {cartItems.length > 0 ? (
          <div className="cart-body">
            <CartList
              toggleCart={toggleCart}
              cartstyle={cartstyle}
              isXSmall={isXSmall}
              cartItems={cartItems}
              handleRemoveFromCart={handleRemoveFromCart}
              handle_AddOneToCart={handle_AddOneToCart}
              handle_RemoveOneFromCart={handle_RemoveOneFromCart}
              handle_itemDiscaunt={handle_itemDiscaunt}
              Edit={{ isEditPrice, isEditQty }}
            />
          </div>
        ) : (
          <div className="empty-cart">
            <BagIcon fillcolor="black" />
            <p>Ваша корзина пустая...</p>
          </div>
        )}
        {cartItems.length > 0 && (
          <div className="cart-checkout">
            <CartSummary
              cartItems={cartItems}
              cartTotal={cartTotal}
              cartQtyTotal={cartQtyTotal}
              setcartdiscount={setcartdiscount}
              cartdiscount={cartdiscount}
              isEditSumm={isEditSumm}
              toggleEditSumm={toggleEditSumm}
              setCartPrice={setCartPrice}
              alltovs={alltovs}
              dispatch={dispatch}
            />
            <Checkout
              handleShopping={handleShopping}
              handleCheckout={handleCheckout}
              placeOrder={placeOrder}
              authenticated={authenticated}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state,
    isCartOpen: state.navigation.isCartOpen,
    cartItems: state.cart.cartItems,
    cartTotal: state.cart.cartTotal,
    cartQtyTotal: state.cart.cartQtyTotal,
    cartstyle: state.cart.cartstyle,
    cartdiscount: state.cart.cartdiscount,
    isEditPrice: state.cart.isEditPrice,
    isEditQty: state.cart.isEditQty,
    isEditSumm: state.cart.isEditSumm,
    authenticated: true, //state.authentication.authenticated,
  };
};

export default connect(mapStateToProps, actions)(Cart);
